import React from 'react';
import { IStore } from 'Store/.';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { staticContent } from './MenuFooterContent';
import { fetchContactContent } from 'Components/InfoContact/Redux/thunks';
import { getContactContent } from 'Components/InfoContact/Redux/selectors';
import MenuFooter from 'Components/MenuFooter/MenuFooter';

interface IPropsInternal {
  infoContact: Julius.Website.ContactPageViewModel;
  fetchContactContent: () => void;
}

type Props = IPropsInternal;

class MenuFooterContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchContactContent();
  }

  getContactMenu = () => {
    const { infoContact } = this.props;

    if (!infoContact) {
      return null;
    }

    return {
      imageUrl: '/logo-BW.svg',
      items: [
        {
          id: infoContact.email,
          displayName: infoContact.email,
          localPath: '/information/kontakt',
          iconType: 'mail',
        },
        {
          id: infoContact.phoneBookings,
          displayName: infoContact.phoneBookings,
          localPath: '/information/kontakt',
          iconType: 'phone',
        },
        {
          id: infoContact.adress,
          displayName: infoContact.adress,
          localPath: '/information/kontakt',
          iconType: 'home',
        },
      ],
    };
  }
  render() {
    const contactMenu = this.getContactMenu();
    return <MenuFooter { ... { contactMenu, ...staticContent } } />
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    infoContact: getContactContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchContactContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(MenuFooterContainer);


// WEBPACK FOOTER //
// ./src/components/MenuFooter/MenuFooterContainer.tsx